import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Dialog } from '@headlessui/react';
import styles from '../ModalHeader.module.scss';

type ModalHeaderContainerProps = {
  children: ReactNode;
  className?: string;
};

export const ModalHeaderContainer = ({
  children,
  className,
}: ModalHeaderContainerProps) => {
  return (
    <header
      className={classNames(styles.ModalHeader, className)}
      data-testid="ModalHeader"
    >
      {/* Wrap with Dialog.Title so HeadlessUI sets aria-labelledby on the modal */}
      <Dialog.Title as="div">{children}</Dialog.Title>
    </header>
  );
};
